module.exports = __webpack_public_path__ + "img/video.69c61489.jpg";